import {ListItem, ListItemProps, Text} from '@chakra-ui/react';
import {FC, PropsWithChildren} from 'react';

interface IProps {
  title: string;
  boxProps?: ListItemProps;
}

export const OrderTotalListItem: FC<PropsWithChildren<IProps>> = ({title, boxProps, children}) => {
  return (
    <ListItem display="flex" alignItems="center" justifyContent="space-between" {...boxProps} py="15px">
      <Text as="span" fontWeight="500" fontSize={['14px', '18px']} textAlign="center">
        {title}
      </Text>
      {children}
    </ListItem>
  );
};
